"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderServicesService = void 0;
var _http = _interopRequireDefault(require("@/config/http"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var fectchAllOrderServices = function fectchAllOrderServices(params) {
  return (0, _http.default)({
    url: "/order-service",
    method: 'get',
    params: params
  });
};
var createOrderService = function createOrderService(payload) {
  return (0, _http.default)({
    url: "/order-service",
    method: 'post',
    data: payload
  });
};
var orderServicesService = exports.orderServicesService = {
  fectchAllOrderServices: fectchAllOrderServices,
  createOrderService: createOrderService
};